import { Text, Tooltip } from '@mantine/core';
import { truncateClientSelectLabel } from '../lib/clientSelectOptions';

/** Single-line truncated option/chip label with full text on hover. */
export function ClientSelectOptionLabel({
  label,
  maxChars = 42,
}: {
  label: string;
  maxChars?: number;
}): JSX.Element {
  const truncated = truncateClientSelectLabel(label, maxChars);
  return (
    <Tooltip label={label} disabled={truncated === label} withArrow openDelay={300}>
      <Text component="span" size="sm" style={{ whiteSpace: 'nowrap' }}>
        {truncated}
      </Text>
    </Tooltip>
  );
}
